module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-pulse-mobile.pl-38abc90031bb0bcef2c69efde11bcff8.png";